import { WithSequenceStatePropsType } from 'components/hoc/withSequenceState';
import withSequenceState from 'components/hoc/withSequenceState';
import CardDetailRecipe from 'components/molecules/Card/Detail/Recipe';
import { CardDetailPropsType } from 'components/molecules/Card/Fragments/CardDetail';
import Sequences from 'defs/sequences';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {
	actionCreators,
	getIsDone,
	getKcal,
	getMenuTypeFilterTagId,
	getNutrition,
	getRecipeCalories,
	getTitle,
	getTotalDuration,
	getTotalDurationFormatted,
	RootStateType,
} from 'store/programItems';
import { actionCreators as transientPoolAC } from 'store/transientPoolState';

export type StateToPropsType = {
	title: ReturnType<typeof getTitle>;
	energy: ReturnType<typeof getKcal>;
	totalDuration: ReturnType<typeof getTotalDuration>;
	totalDurationFormatted: ReturnType<typeof getTotalDurationFormatted>;
	isDone: ReturnType<typeof getIsDone>;
	menuTypeFilterTagId: ReturnType<typeof getMenuTypeFilterTagId>;
	calories: ReturnType<typeof getRecipeCalories>;
	nutrition: ReturnType<typeof getNutrition>;
};
export type DispatchToPropsType = typeof actionCreators & {
	doSetProgramItemRef: typeof transientPoolAC.doSetProgramItemRef;
	doSetPersistentFilter: typeof transientPoolAC.doSetPersistentFilter;
};

const mapStateToProps = (state: RootStateType, ownProps: CardDetailPropsType): StateToPropsType => ({
	title: getTitle(state, ownProps.id),
	energy: getKcal(state, ownProps.id),
	totalDuration: getTotalDuration(state, ownProps.id),
	totalDurationFormatted: getTotalDurationFormatted(state, ownProps.id),
	isDone: getIsDone(state, ownProps.id),
	menuTypeFilterTagId: getMenuTypeFilterTagId(state, ownProps.id),
	calories: getRecipeCalories(state, ownProps.id),
	nutrition: getNutrition(state, ownProps.id),
});

const mapDispatchToProps = (dispatch): DispatchToPropsType => {
	return bindActionCreators(
		{
			...actionCreators,
			doSetProgramItemRef: transientPoolAC.doSetProgramItemRef,
			doSetPersistentFilter: transientPoolAC.doSetPersistentFilter,
		},
		dispatch
	);
};

export type ContainerCardDetailRecipePropsType = CardDetailPropsType &
	StateToPropsType &
	DispatchToPropsType &
	WithSequenceStatePropsType;

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(withSequenceState(CardDetailRecipe, [Sequences.CARD_IS_CHECKING, Sequences.CARD_IS_POSTPONING]) as any);
